(function () {
    'use strict';

    angular
        .module('SodCustomAction')
        .factory('ActionCommon', ActionCommon);

    function ActionCommon($injector, ActionModel, lodash, $rootScope) {
        return {
            show_floating_notifier: show_floating_notifier,
            show_static_notifier: show_static_notifier,
            show_dialog: show_dialog
        };

        function show_floating_notifier(data) {
            var notifier = $injector.get('notifier');
            notifier.notify({
                template: data.template || '&nbsp;',
                hasDelay: data.hasDelay || true,
                delay: data.delay || 3000,
                type: data.type || '', // default success warning info error
                position: data.position || 'top center'
            });
        }

        function show_static_notifier(data) {
            // {
            //     name: viewModel.options.form.name,
            //     message:'Test 123',
            //     // classes: 'error',
            //     // icon: 'exclamation-triangle',
            //     classes: 'success-inverted text-center',
            //     type: 'success-animated',
            //     delay: 3000
            // }
            // Either use classes with icon, or success-inverted with type

            var $timeout = $injector.get('$timeout');
            $timeout(function() {
	            ActionModel.set('static-notifier', data.name, data);
	            if (lodash.has(data, 'delay') && data.delay !== null) {
		            $timeout(function() {
			            ActionModel.set('static-notifier', data.name, {});
		            }, data.delay);
	            }
            });
        }

        function show_dialog(data, model) {
            var ModalService = $injector.get('ModalService'),
                ButtonRegistry = $injector.get('ButtonRegistry'),
                ListFilterStateFactory = $injector.get('ListFilterStateFactory');
            ModalService.showModal({
                templateUrl: data.templateUrl,
                controller: data.controller,
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogModel: model,
                    dialogOptions:  lodash.get(data,'dialogOptions', {})
                }
            }).then(function (modal) {
                dialogManipulatePace(true);
                ButtonRegistry.clearAllLoading();
                modal.info = model;
                modal.element.show();
                modal.close.then(function (result) {
                    var refreshGrid = lodash.get(result, 'datasourceRefresh', false);
                    if (refreshGrid) {
                        var listFilterService = ListFilterStateFactory.get(lodash.get(data, 'identifier', null));
                        listFilterService.refreshGrid();
                    }
                    dialogManipulatePace(false);
                });
            });
        }

        function dialogManipulatePace(state) {
            if (state) {
                angular.element('body').addClass('dialog-active');
            } else {
                angular.element('body').removeClass('dialog-active');
            }
        }
    }
})();
